import {
  CloneButton,
  DateField,
  DeleteButton,
  EditButton,
  Icons,
  List,
  RefreshButton,
  ShowButton,
  Space,
  Table,
  Tag,
  Typography,
  useModalForm,
  Popconfirm,
  Button,
  Input,
  Divider,
  useTable,
  Form,
  SaveButton,
  getDefaultSortOrder,
  Row,
  Col,
} from '@pankod/refine-antd'
import { BaseKey, useNavigation, useShow, useUpdate, useOne, useGetIdentity } from '@pankod/refine-core'
import { TableColumnsType } from 'antd'
import { IPaper, IPaperRequest, ITestEvent } from 'interfaces'
import React, { useEffect, useState } from 'react'
import { EditTestEventWorkRequest } from 'pages/paperrequests'

import { useUserContext } from 'context/user'

import metaData from 'metadata/paperRequests'
import paperMetaData from 'metadata/paper'
import Permissions from 'permissions'
import { getCount } from 'gql/query'
const { Text } = Typography
type PaperRequestTableProps = {
  request?: any
}
type Permission = {
  granted?: boolean
}
interface Count {
  openCount: number
  completedCount: number
  inProgressCount: number
  totalCount: number
}

export const PaperRequestTable: React.FC<PaperRequestTableProps> = ({ request }) => {
  const { show, push } = useNavigation()
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  //count
  const [paperRequestCount, setPaperRequestCount] = useState<Count>({ openCount: 0, completedCount: 0, inProgressCount: 0, totalCount: 0 })
  const [currentPage, setCurrentPage] = useState(parseInt(localStorage.getItem(`paperrequest-${userRole}`) ?? '1'))
  const [current, setCurrent] = useState(1)
  //access control
  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})

  const findCount = async () => {
    try {
      let userId = user?.id
      let isAdmin = userRole === 'admin'
      let userrole = userRole
      const resource = 'paper requests'
      const responseFindCountPaperRequests: any = await getCount({ userId, isAdmin, userrole, resource })
      let openCount = responseFindCountPaperRequests?.openPaperRequestCount?.aggregate?.count
      let inProgressCount = responseFindCountPaperRequests?.inProgressPaperRequestCount?.aggregate?.count
      let completedCount = responseFindCountPaperRequests?.completedPaperRequestCount?.aggregate?.count
      let totalCount = openCount + inProgressCount + completedCount
      setPaperRequestCount({ openCount, completedCount, inProgressCount, totalCount })
    } catch (err) {
      console.log(err, 'error from finding count')
    }
  }

  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('paper_requests'))
      setCreatePermission(Permissions.can(userRole).createAny('paper_requests'))
      setEditPermission(Permissions.can(userRole).updateAny('paper_requests'))
      setDeletePermission(Permissions.can(userRole).deleteAny('paper_requests'))
    }
  }, [userRole])

  useEffect(() => {
    if (
      !readPermission?.granted &&
      readPermission?.granted !== undefined &&
      userRole !== 'deliverymanager' &&
      userRole !== 'evaluationincharge' &&
      userRole !== 'evaluators'
    ) {
      push('/')
    } else {
      findCount()
    }
  }, [readPermission])

  const [hasPagination, setHasPagination] = useState<any>(true)

  const { queryResult, setShowId } = useShow<IPaperRequest>({
    resource: 'paper_requests',
    metaData: metaData,
  })

  // const { tableQueryResult: paperQueryResult } = useTable<IPaper>({ resource: 'papers', metaData: paperMetaData })

  // const { mutate: updatePaperTemplateAcitve } = useUpdate()
  const { data: showQueryResult } = queryResult
  const record = showQueryResult?.data
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: 'paper_requests',
    action: 'edit',
    redirect: false,
    metaData,
  })
  const isPaper_Template = window.location.pathname.includes('paper_requests')
  const { filters, setFilters, tableQueryResult, sorter, tableProps, searchFormProps } = useTable<IPaperRequest>({
    resource: 'paper_requests',
    hasPagination,
    initialCurrent: isPaper_Template ? currentPage : current,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    // initialFilter: [
    //   {
    //     field: 'test_event_id',
    //     operator: 'eq',
    //     value: request?.id,
    //   },
    // ],
    metaData,
    onSearch(data: any) {
      return [{ field: 'name', operator: 'contains', value: `%${data?.name}%` }]
    },
  })

  const hideDeleteButton = (record: IPaperRequest): boolean => {
    if (record?.papers !== undefined) {
      const shouldHide = record.papers.length > 0
      return shouldHide
    }
    return false
  }

  useEffect(() => {
    if (userRole !== undefined) {
      if (request?.id !== undefined) {
      } else {
        filters !== undefined && filters.pop()
        setFilters([])
        if (userRole === 'papersetter') {
          setFilters([{ field: 'paper_setter_id', operator: 'eq', value: user?.id }])
        }
        if (userRole === 'paperapprover') {
          setFilters([{ field: 'paper_approver_id', operator: 'eq', value: user?.id }])
        }
        if (userRole === 'productmanager') {
          // setFilters([{ field: 'created_by', operator: 'eq', value: user?.id }])
        }
      }
    }
  }, [userRole, request])

  useEffect(() => {
    if (request?.id) {
      setFilters([
        {
          field: 'test_event_id',
          operator: 'eq',
          value: request?.id,
        },
      ])
    }
  }, [request])

  const onChange = (page: number, pageSize?: any): void => {
    setCurrentPage(page)
    setCurrent(page)
    localStorage.setItem(`paperrequest-${userRole}`, page.toString())
  }

  const searchByName = (value: any) => {
    // setHasPagination(false)
    setFilters([
      {
        field: 'name',
        operator: 'contains',
        value: `%${value}%`,
      },
    ])
  }

  const columns: TableColumnsType<IPaperRequest> = [
    {
      dataIndex: 'id',
      title: 'Id',
      render: (item, record, index) => <>{index + 1}</>,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      render: (_, record) =>
        record?.created_by !== undefined && (
          <>
            {/* {record?.created_by === user?.id || userRole !== 'productmanager' ? ( */}
            {record?.created_by === user?.id || userRole !== '' ? (
              <ShowButton
                size="small"
                type="link"
                icon={null}
                recordItemId={record.id}
                onClick={() => {
                  show('paper_requests', record.id)
                }}
              >
                <Text
                  style={{
                    width: 200,
                    textAlign: 'left',
                    color: '#6659FF',
                    cursor: 'pointer',
                  }}
                  ellipsis={{ tooltip: record?.name }}
                >
                  {record?.name}
                </Text>
              </ShowButton>
            ) : (
              <Text>{record?.name}</Text>
            )}
          </>
        ),
    },

    {
      dataIndex: 'status',
      title: 'status',
      // width: 100,
      className: 'ant-table-column-sort',
      render: value => (
        <Tag color={value === 'Completed' ? 'green' : value === 'Draft' ? 'pink' : value === 'Closed' ? 'volcano' : 'geekblue'}>{value}</Tag>
      ),
    },
    // {
    //   dataIndex: 'paper_setter_id',
    //   title: 'Paper Setter',
    //   render: (_, record) => (
    //     <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.paper_setters?.displayName }}>
    //       {record?.paper_setters?.displayName}
    //     </Text>
    //   ),
    // },
    // {
    //   dataIndex: 'paper_approver_ids',
    //   title: 'Paper Approver',
    //   render: (_, record) => (
    //     <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.paper_approvers?.displayName }}>
    //       {record?.paper_approvers?.displayName}
    //     </Text>
    //   ),
    // },
    // {
    //   dataIndex: 'paper_template_id',
    //   title: 'Paper Template',
    //   render: (_, record) => (
    //     <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.paper_templates?.name }}>
    //       {record?.paper_templates?.name}
    //     </Text>
    //   ),
    // },
    { dataIndex: 'paper_template', title: 'Paper Template', render: value => <Text ellipsis={{ tooltip: value?.name }}>{value?.name}</Text> },
    {
      dataIndex: 'test_event',
      title: 'Test Event',
      render: value => <Text ellipsis={{ tooltip: value?.name }}>{value?.name}</Text>,
    },
    {
      dataIndex: 'userByPaperSetter',
      title: 'Paper Setter',
      render: value => <Text ellipsis={{ tooltip: value?.displayName }}>{value?.displayName}</Text>,
    },
    {
      dataIndex: 'userByPaperApprover',
      title: 'Paper Approver',
      render: value => {
        return <Text ellipsis={{ tooltip: value?.displayName }}>{value?.displayName}</Text>
      },
    },
    {
      dataIndex: 'created_at',
      title: 'Created At',
      render: value => <DateField value={value} format="LLL" />,
      sorter: { multiple: 1 },
      defaultSortOrder: getDefaultSortOrder('created_at', sorter),
      showSorterTooltip: true,
    },
    {
      //   className: editPermission !== undefined && editPermission?.granted ? 'show' : 'hide',
      title: 'Actions',
      dataIndex: 'actions',
      render: (_, record) => (
        <Space>
          <EditButton
            key="pr_edit"
            size="small"
            type="link"
            hideText
            title="Edit"
            recordItemId={record.id}
            onClick={() => {
              setShowId(record.id)
              editShow(record.id)
            }}
            hidden={hideDeleteButton(record) || userRole === 'papersetter' || userRole === 'paperapprover'}
          />

          {/* <CloneButton
            key="pr_clone"
            size="small"
            type="link"
            hideText
            title="Clone"
            icon={<Icons.CopyOutlined />}
            recordItemId={record.id}
            onClick={() => {
              // setShowId(record.id)
              // cloneShow(record.id)
            }}
          /> */}

          {/* <Popconfirm
            title="Delete Paper Request ?"
            onConfirm={() => updatePaperTemplateAcitve({ resource: 'paper_request', id: record.id, values: { active: 'false' } })}
          >
            <DeleteButton danger size="small" type="link" hidden={hideDeleteButton(record)}>
              <Icons.DeleteOutlined />
            </DeleteButton>
          </Popconfirm> */}

          <DeleteButton
            resourceNameOrRouteName="paper_requests"
            key="pr_delete"
            size="small"
            type="link"
            title="Delete"
            hideText
            recordItemId={record.id}
            hidden={hideDeleteButton(record) || userRole === 'papersetter' || userRole === 'paperapprover'}
            onSuccess={() => findCount()}
          />
        </Space>
      ),
    },
  ]
  return (
    <>
      <List
        title="Paper Requests"
        pageHeaderProps={{
          extra: [<RefreshButton key="refresh" onClick={() => tableQueryResult?.refetch()} />],
        }}
      >
        {!request.id && (
          <>
            <Divider />
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={12} lg={8} xl={6}>
                <div
                  style={{
                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                    padding: '1rem',
                    height: '4rem',
                    borderRadius: '10px',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <h4>
                    Total Paper Requests :{' '}
                    <span style={{ fontSize: '16px', marginLeft: '5px', fontWeight: 'bold' }}>{paperRequestCount?.totalCount}</span>
                  </h4>
                </div>
              </Col>
              <Col xs={24} sm={12} md={12} lg={8} xl={6}>
                <div
                  style={{
                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                    padding: '1rem',
                    height: '4rem',
                    borderRadius: '10px',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <h4>
                    Open Paper Requests :{' '}
                    <span style={{ fontSize: '16px', marginLeft: '5px', fontWeight: 'bold' }}>{paperRequestCount?.openCount}</span>
                  </h4>
                </div>
              </Col>
              <Col xs={24} sm={12} md={12} lg={8} xl={6}>
                <div
                  style={{
                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                    padding: '1rem',
                    height: '4rem',
                    borderRadius: '10px',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <h4>
                    Completed Paper Requests :{' '}
                    <span style={{ fontSize: '16px', marginLeft: '5px', fontWeight: 'bold' }}> {paperRequestCount?.completedCount}</span>
                  </h4>
                </div>
              </Col>
              <Col xs={24} sm={12} md={12} lg={8} xl={6}>
                <div
                  style={{
                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                    padding: '1rem',
                    height: '4rem',
                    borderRadius: '10px',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <h4>
                    In Progress Paper Requests :{' '}
                    <span style={{ fontSize: '16px', marginLeft: '5px', fontWeight: 'bold' }}> {paperRequestCount?.inProgressCount}</span>
                  </h4>
                </div>
              </Col>
            </Row>
          </>
        )}
        <Divider />
        {/* <Input.Search
        placeholder="Search By Name"
        onChange={e => {
          if (e.type === 'click') {
            setHasPagination(true)
          }
        }}
        allowClear
        style={{ width: '100%' }}
        onSearch={(value: any) => searchByName(value)}
      /> */}
        <Form {...searchFormProps}>
          <Space>
            <Form.Item name="name">
              <Input placeholder="Search by Name" />
            </Form.Item>
            <Button type="primary" icon={<Icons.SearchOutlined />} onClick={searchFormProps.form?.submit}>
              Search
            </Button>
            <Button
              onClick={() => {
                searchFormProps?.form?.setFieldsValue({ name: '' })
                searchFormProps.form?.submit()
              }}
            >
              Clear
            </Button>
          </Space>
        </Form>
        <Divider />

        <Table
          {...tableProps}
          rowKey="id"
          size="small"
          columns={columns}
          // dataSource={tableQueryResult?.data?.data}
          pagination={{
            total: tableQueryResult?.data?.total,
            onChange,
            current: isPaper_Template ? currentPage : current,
          }}
        />
        <EditTestEventWorkRequest formProps={editFormProps} modalProps={editModalProps} record={record} request={request} />
      </List>
    </>
  )
}
